/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProfileAddressesCreate = 'route-profile-addresses-create',
	uiSelectCountryCode = 'ui-select-country-code',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).profile.addresses.create',
	profileAddresses = 'routes/($lang).profile.addresses',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	firstName = 'firstName',
	lastName = 'lastName',
	phoneNumber = 'phoneNumber',
	company = 'company',
	street = 'street',
	city = 'city',
	postcode = 'postcode',
	countryCode = 'countryCode',
	defaultAddress = 'defaultAddress',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PROFILE_ADDRESSES_CREATE_I18NEXT,
	ROUTE_LOADER as PROFILE_ADDRESSES_CREATE_ROUTE_LOADER,
	SEARCH_PARAMS as PROFILE_ADDRESSES_CREATE_SEARCH_PARAMS,
}
